<p-dialog
  [(visible)]="dialogVisible"
  [header]="currentStep === 0 ? (('select.devices' | transloco) + ' (1/2)') : (('select.measurements' | transloco) + ' (2/2)')"
  [style]="{ width: '90vw' }"
  [draggable]="false"
  [resizable]="true"
  [modal]="true"
  (onHide)="visibleChange.emit(false)"
  appendTo="body"
>
  <div *ngIf="dialogVisible">
    <app-devices-step
      *ngIf="currentStep === 0"
      [(deviceSelection)]="deviceSelection"
      [(deviceFilters)]="deviceFilters"
      [tenant]="tenant"
      [organization]="organization"
      [selectionMode]="selectionMode"
      (deviceSelectionChange)="updateDeviceMeasurementSelection($event)"
    ></app-devices-step>
    <app-device-measurements-step
      *ngIf="currentStep === 1"
      [(deviceMeasurementSelection)]="deviceMeasurementSelection"
      [(deviceMeasurementFilters)]="deviceMeasurementFilters"
      [tenant]="tenant"
      [selectionMode]="selectionMode"
      [deviceSelection]="deviceSelection"
    ></app-device-measurements-step>
  </div>

  <div class="flex justify-content-between pt-4">
    <div>
      <button
        [label]="'common.cancel' | transloco"
        (click)="closeWithoutSaving()"
        pButton
        class="mr-2 p-button-danger"
      ></button>
    </div>
    <div class="flex justify-content-end">
      <button
        *ngIf="currentStep === 0"
        [label]="'common.next' | transloco"
        [disabled]="!deviceSelection || deviceSelection.length === 0"
        [class.p-button-danger]="selectionMode === 'multiple' && deviceSelection.length > 100"
        [pTooltip]="'error.tooMany.devices' | transloco"
        [tooltipDisabled]="selectionMode === 'single' ||  deviceSelection.length <= 100"
        (click)="(selectionMode === 'single' || deviceSelection.length <= 100) ? currentStep = currentStep + 1 : ''"
        pButton
        icon="pi pi-chevron-right"
        class="mr-2"
        iconPos="right"
      ></button>
      <button
        *ngIf="currentStep === 1"
        [label]="'common.previous' | transloco"
        (click)="currentStep = currentStep - 1"
        pButton
        icon="pi pi-chevron-left"
        class="mr-2"
        iconPos="left"
      ></button>
      <div *ngIf="currentStep === 1">
        <button
          [label]="'common.select' | transloco"
          [disabled]="!deviceMeasurementSelection || deviceMeasurementSelection.length === 0"
          (click)="saveAndClose()"
          pButton
          icon="pi pi-check"
          iconPos="right"
        ></button>
      </div>
    </div>
  </div>
</p-dialog>
